import React, { Component, useState } from "react";
import Table from "../../../utilities/table";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Button, Modal } from "react-bootstrap";
import FormContainer from "../../../../containers/modules/accounting/journal/form";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import withReactContent from "sweetalert2-react-content";
import TableJournal from "./table";
import SwitchButton from "../../../utilities/Form/SwitchButton";
import { Link } from "react-router-dom";
import i18n from "../../../../i18n";
import { statusMemoIn } from "../../../utilities/Const/StatusJournal";
import LabelActiveJournal from "../../../utilities/Status/journal";
const MySwal = withReactContent(Swal);
export class Journal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
      },
      titleModal: "",
      listData: [],
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Accounting"), class: " text-gray-600" },
        { link: null, title: i18n.t("Journal"), class: " text-gray-500" },
      ],
      column: [
        {
          key: "no_journal",
          key2: "id",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Journal No."),
          type: "component",
          component: (data, column) => {
            if (data.status == 1 || data.status == 0) {
              return (
                <td>
                  <Link
                    to={"/accounting/journal/detail/" + data.id}
                  >
                    {data[column.key]}{" "}
                  </Link>
                </td>
              );
            } else {
              return <td>{data[column.key]} </td>;
            }
          },
        },
        {
          key: "date_format",
          filter: { active: true, type: "DateBetween", data: null },
          title: i18n.t("Journal Date"),
          type: "text",
          tHclass: "min-w-120px",
          tdClass: "",
        },
        {
          key: "description",
          filter: { active: true, type: "Text", data: null },
          title: i18n.t("Description"),
          type: "text",
          tHclass: "min-w-140px",
          tdClass: "",
        },
        {
          key: "debt_format",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Debt"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "credit_format",
          filter: { active: false, type: "Text", data: null },
          title: i18n.t("Credit"),
          type: "text",
          tHclass: "min-w-125px",
          tdClass: "",
        },
        {
          key: "balance_name",
          filter: {
            active: false,
            type: "Select",
            data: [
              { key: "", label: i18n.t("Select Status") },
              { key: 1, label: i18n.t("Active") },
              { key: 0, label: i18n.t("Non Active") },
            ],
          },
          title: i18n.t("Balance"),
          type: "active",
          tHclass: "min-w-120px",
          tdClass: "",
        },
        {
          key: "status",
          filter: {
            active: true,
            type: "Select",
            data: statusMemoIn,
          },
          title: i18n.t("Status"),
          type: "component",
          tHclass: "min-w-125px",
          tdClass: "",
          component: (data, column) => {
            return <LabelActiveJournal value={data[column.key]} />;
          },
        },
      //  {
      //     key: "status",
      //     filter: { active: false, type: "Select", data: null },
      //     title: i18n.t("Check"),
      //     type: "component",
      //     component: (data, column) => {
      //       if (data.status == 1 || data.status == 3) {
      //         return (
      //           <SwitchButton
      //             labelfield={"false"}
      //             onChange={async (e) => {
      //               await this.choose(e, data.id);
      //               await this.runSearch(this.state.search);
      //             }}
      //             name={"check"}
      //             // checked={data.status == 3}
      //             value={data[column.key]}
      //             className={"h-20px w-30px"}
      //           ></SwitchButton>
      //         );
      //       }
      //     },
      //     tHclass: "text-center min-w-120px",
      //     tdClass: "",
      //   },
        {
          key: "createdAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Created At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "updatedAt",
          filter: { active: false, type: "Select", data: null },
          title: i18n.t("Updated At"),
          type: "custom",
          tHclass: "text-center min-w-125px",
          tdClass: "",
        },
        {
          key: "id",
          filter: {
            active: false,
          },
          title: i18n.t("Action"),
          type: "action",
          tHclass: "text-center min-w-150px",
          tdClass: "text-center",
          key: "id",
          form:'icon',
          buttons:[
            {
              key: "id",
              btnText: i18n.t("Print"),
              visible: {
                key: "status",
                params: [],
                function: (id, params) => {
                  const {authUser}=this.props
                  if(Object.keys(authUser).length >0 && authUser.userAccess!= undefined){
                    let route=authUser.userAccess.route
                    if(route.includes('Journal Print')){
                      return true
                    }
                  }
                  return false;
                },
              },
              btnLink:"/accounting/memo-in/print/",
              btnFunction: (data, column) => {
                // this.cancelData(data);
              },
              bthClass: "btn btn-danger",
            },
          ],
        },
      ],
    };
    this.runSearch = this.runSearch.bind(this);
    this.updateData = this.updateData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.createData = this.createData.bind(this);
    this.choose = this.choose.bind(this);
  }

  choose(e, data) {
    this.props.changeItem(data);
  }
  runSearch(value) {
    this.state.submit = false;
    this.props.search(value);
  }
  createData() {
    this.state.titleModal = i18n.t("Add Journal");
    this.props.createData();
  }
  updateData(id) {
    this.state.titleModal = i18n.t("Edit Journal");
    this.props.updateItem(id);
  }
  deleteData(id) {
    const html = (
      <>
        <div>{i18n.t("You will delete this Item")}</div>
        <Button variant="warning" onClick={() => MySwal.close()}>
          {i18n.t("Cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            this.props.deleteItem(id, this.state.search);
            MySwal.update({
              title: i18n.t("Deleting Data"),
              html: i18n.t("Please Wait ...."),
              icon: i18n.t("info"),
            });
            MySwal.showLoading();
          }}
        >
          {i18n.t("Delete")}
        </Button>
      </>
    );
    MySwal.fire({
      title: i18n.t("Are you sure?"),
      html: html,
      icon: i18n.t("question"),
      showCancelButton: false,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  }
  submitForm(status) {
    this.setState({ submit: status });
  }
  addJournal(data) {
    this.props.payment(data, "multiple");
  }
  render() {
    const { isProcessing, data, showModal } = this.props;
    this.state.listData = data;
    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-header d-flex justify-content-end border-0 pt-6">
                <div className="card-toolbar">
                  <div
                    className="d-flex justify-content-end"
                    data-kt-customer-table-toolbar="base"
                  >
                    <Button
                      type="button"
                      className="btn btn-warning m-1"
                      onClick={(e) => this.runSearch(this.state.search)}
                    >
                      <FontAwesomeIcon icon={faSync}></FontAwesomeIcon>
                    </Button>
                    <Button
                      type="button"
                      className="btn btn-primary m-1"
                      onClick={(e) => this.createData()}
                    >
                      {i18n.t("Add Journal")}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <TableJournal
                  checkAble={false}
                  numberAble={true}
                  expandAble={true}
                  theExpand={{
                    key: "journal_detail",
                    columns: [
                      { label: i18n.t("Ledger"), key: "name_coa3" },
                      { label: i18n.t("Helper Book"), key: "name_coa_help" },
                      {
                        label: i18n.t("Debt"),
                        key: "debt_format",
                        key2: "total_debt_format",
                      },
                      {
                        label: i18n.t("Credit"),
                        key: "credit_format",
                        key2: "total_credit_format",
                      },
                      { label: i18n.t("Description"), key: "description" },
                    ],
                  }}
                  data={this.state.listData}
                  tools={false}
                  filterSearch={true}
                  column={this.state.column}
                  searchData={this.state.search}
                  runSearch={this.runSearch}
                  deleteData={this.deleteData}
                  updateData={this.updateData}
                  isProcessing={isProcessing}
                />
              </div>
            </div>
          </div>
        </div>
        <FormContainer
          showModal={showModal}
          search={this.state.search}
          titleModal={this.state.titleModal}
        />
      </div>
    );
  }
}

export default Journal;
